window.testEnv = process.env.NODE_ENV;

/**
 * Дорисовка jQuery в глобальном виде
 * Отключил поскольку ниже стоячии библиотеки требуют определенной видимости
 */

if (1) {
	const jQuery = window.$ = window.jQuery = require('jquery');
	// const $ = jQuery;
}
if(window.testEnv === 'production') {
	window.ProjectVersion = PROJECT_VERSION;
	if(window.ProjectVersion){
		console.log('project version = ' + window.ProjectVersion);
	}
}
/*
Підключаєм тільки ті стилі, які будуть на всіх сторінках
*/
require('__scss/grid.scss');					    // сітка
require('__scss/text.scss');					    // стилі тектсу
require('__scss/fonts.scss');					// шрифти
// require('__scss/awesome.scss');					// іконци
require('perfect-scrollbar/dist/css/perfect-scrollbar.css');	// perfect scrollbar
require('__scss/slick.scss'); 					// slick
// require('__scss/slick-theme.scss');
// material design
require('__scss/nouislider.css');


//полифил

window.noUiSlider = require('nouislider');
require('./multirangeContainer/multirangeContainer.js');
require('__scss/multirangeContainer/multirangeContainer.scss');
//функция делает формат цены
window.priceFormat = require('./price-format/price-format.js');

// require('__scss/materialize_form_date/materialize.scss');

/**
 * Где-то в этом модуле месте сатана делает подключение к jQuery
 */
// require('__scss/materialize.scss');
// require('materialize-css');
    require('./waves.js');

const fancybox = require('./jquery.fancybox.js');
$.fancybox.defaults.autoFocus = false;
if(window.innerWidth < 640) {
	$.fancybox.defaults.btnTpl.arrowRight = '';
	$.fancybox.defaults.btnTpl.arrowLeft = '';
	$.fancybox.defaults.touch = false;
}


window.fancybox = fancybox;
window.Inputmask = require('inputmask');
window.perfectScrollbar = require('perfect-scrollbar/jquery')($);

//preloader
window.preloader = require('./preloader/preloader.js');

require('__libs/validator.js');
require('__libs/share.js');

//popup forma инициализация photo
require('__libs/inputTypeFile.js');
require('__libs/addDomElement.js');
require('__libs/data-yam-popup.js');
// require('__libs/castomSelect.js');
//QR Code
require('__libs/jquery.qrcode.min.js');
// fixed header
require('__libs/fixed-header.js');
//полифил для шапки сайта браузеры Safari IE
require('intersection-observer');
//полифил для переменных IE
// var varIE = require('./polifil-IE-var.js');
// varIE.init();

//polifil css-variables
window.cssVars = require('css-vars-ponyfill');
//определяем браузер пользователя
function get_name_browser(){
	// получаем данные userAgent
	var ua = navigator.userAgent;
	// с помощью регулярок проверяем наличие текста,
	// соответствующие тому или иному браузеру
	if (ua.search(/Chrome/) > 0) return 'Google Chrome';
	if (ua.search(/Firefox/) > 0) return 'Firefox';
	if (ua.search(/Opera/) > 0) return 'Opera';
	if (ua.search(/Safari/) > 0) return 'Safari';
	if (ua.search(/MSIE/) > 0 || ua.search(/Trident/) > 0) return 'Internet Explorer';

	// условий может быть и больше.
	// сейчас сделаны проверки только
	// для популярных браузеров
	return 'Не определен';
}
//усли браузер ИЕ врубить полифил
if(get_name_browser() === 'Internet Explorer') {
	cssVars.default({
		// Only styles from CodePen's CSS panel
		include: 'style,link[rel="stylesheet"]:not([href*="//"])',
	});
}
//tabs
window.YamTabs =  require('./tabs.js');
require('owl.carousel/src/scss/owl.carousel.scss');
require('owl.carousel');

//scroll element
window.scrollElement = require('__libs/scroll-element/scroll-element.js');
//полифил для fetch запросов
require('whatwg-fetch');
require('./lazy-img/lazy-img.js');
require('./data-lazy-effect/index.js');
require('__scss/data-lazy-effect/data-lazy-effect.scss');

require('__scss/content/content.scss');

require('./global/functions/functions.js');
require('./components');
require('__scss/components.scss');

const mc = {
    runVue: function(array) {
        if(array && array.length) {
            window.VueInstances = {};
            Vue.use(VueResource);
			Vue.directive('$model', {
				bind: function (el, binding, vnode) {
					el.oninput = () => (vnode.context[binding.expression] = el.value)
				}
			})
            // console.log(array);
            array.map(component => {
                Vue.component(component, require(`__components/${component}.vue`));
                window.VueInstances[component] = {};
				// console.log(window.VueInstances[component]);
            });
            const components = document.querySelectorAll('[is]');
            // console.log(components);
            // console.log(components);
            // шукаєм всі діви із атрибутом "is" та запускаєм компоненти
            for(let i = 0; i < components.length; i++) {
                // console.log(components[i]);
                // перевіряєм, чи включений компонент в процес збірки проекту
                if(window.VueInstances[components[i].getAttribute('is')]) {
                    if(components[i].getAttribute('data-params')) {
                        let str = components[i].getAttribute('data-params');
                        str = str.replace(/'/g, '"');
                        let params = JSON.parse(str);
                        window.VueInstances[components[i].getAttribute('is')][params.template] = new Vue({ el: components[i] });
                        // console.log( window.VueInstances[components[i].getAttribute('is')][params.template] = new Vue({ el: components[i] }));
                    } else {
                        console.warn('dataParams is no defined', components[i]);
                    }
                } else {
                    console.warn(`Component ${components[i].getAttribute('is')} is not enabled, but used! Check module constructor options.`);
                }
            }
        }
    },
    runComponents: function(arComponents) {
        if (arComponents && arComponents.length > 0) {
            arComponents.map(componentName => {
                if (typeof this[componentName] === 'undefined') {
                    this[componentName] = require('__libs/'+componentName);
                }
            });
        }
    },
    runFooter: function() {
        STACK.forEach(f => {
            f($);
        });
        // запускаєм скріпти які повинні запускатися при ajax
        $("body").trigger('ajaxResponse');
    }
};
module.exports = mc;
NodeList.prototype.forEach = function(f) {
	for(var i = 0; i < this.length; i++) {
		f(this[i], i);
	}
};



// WEBPACK FOOTER //
// ./libs/ModuleConstructor.js